export default __webpack_public_path__ + "static/media/D2013_12_25_Legnica.eb45db7f.jpg";